import { ArtifactsService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';

/**
 * Saves a live widget's output (`sourceArtifactId`) as a context-less workspace
 * artifact and returns the saved artifact's id. `kind` selects the backend
 * registry entry (`copy`/`image`/`video`/…) on the generic save-widget route;
 * the backend resolves the content by id and keys the saved artifact by the
 * source widget's generation turn, so re-saving the same output is idempotent.
 */
export const saveWidgetArtifact = async (
  kind: string,
  workspaceId: string,
  sourceArtifactId: string,
): Promise<string> => {
  const response = await ArtifactsService.saveWidgetArtifact({
    client: inferenceHttp,
    path: { workspaceId, kind },
    body: { sourceArtifactId },
  });

  if (!response.data) {
    throw new Error(`Failed to save ${kind} artifact`);
  }

  return response.data.id;
};
